var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1236",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#aad4a9",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1154",
    x: 15.002,
    y: 15,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#aad4a9",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_icon",
    "data-name": "delete icon",
    transform: "translate(29.635 30.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -29.63, -30.19)",
    filter: "url(#Ellipse_1236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1236-2",
    "data-name": "Ellipse 1236",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(30 30)",
    fill: "#dc3545",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -29.63, -30.19)",
    filter: "url(#Ellipse_1236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154-2",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(45 45)",
    fill: "#dc3545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "delete_5_",
    "data-name": "delete (5)",
    transform: "translate(36.974 33.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19512",
    "data-name": "Path 19512",
    d: "M2.13,9.549V28.058a4.145,4.145,0,0,0,1.1,2.859,3.7,3.7,0,0,0,2.684,1.161H20.13a3.7,3.7,0,0,0,2.684-1.161,4.145,4.145,0,0,0,1.1-2.859V9.549a2.87,2.87,0,0,0-.736-5.643H19.334V2.966A2.951,2.951,0,0,0,16.359,0H9.688A2.951,2.951,0,0,0,6.713,2.966v.939H2.867A2.87,2.87,0,0,0,2.13,9.549Zm18,21.026H5.917a2.379,2.379,0,0,1-2.284-2.517V9.615H22.414V28.058a2.379,2.379,0,0,1-2.284,2.517ZM8.215,2.966A1.447,1.447,0,0,1,9.688,1.5h6.671a1.447,1.447,0,0,1,1.473,1.465v.939H8.215ZM2.867,5.408H23.18a1.352,1.352,0,0,1,0,2.7H2.867a1.352,1.352,0,0,1,0-2.7Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.ea9acea562a194c44c54fc6dc63422e1.svg";
export { ForwardRef as ReactComponent };